module.exports = __webpack_public_path__ + "img/shared7.2a6a5500.png";